import { createSlice } from "@reduxjs/toolkit";

const initialExperimentState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  lastError: null,
  filteredEntities: "",
  experimentFetchedById: "",
  experimentChartById: "",
  modelDetailsData: ""
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const modelDetails = createSlice({
  name: "modelDetails",
  initialState: initialExperimentState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
        state.entities = [];
      } else {
        state.actionsLoading = false;
        state.entities = [];
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    modelCreated: (state, action) => {
      state.listLoading = false;
      state.actionsLoading = false;
      state.modelDetailsData = action.payload;
      state.error = null;
    }
  }
});
